/**
 * 接口响应通用类型
 */
export type Response<T = any, E = any> = {
  total?: number
  code: number // 响应编码:0/200-请求处理成功
  msg: string // 提示消息
  path?: string // 请求路径
  traceId?: string // tid
  extra?: E // 附加数据
  timestamp?: number // 响应时间戳
  isSuccess?: boolean
  isError?: boolean
  data: T
}

// 通用page response 类型
export type Page<T = any> = {
  size: number
  current: number
  records: T[]
  total: number
  pages?: number
}
export type PageResponse<T = any, E = any> = Response<Page<T>, E>

// 通用page request 类型
export type PageRequest<T = any> = {
  current?: number
  map?: Record<string, string>
  model?: T
  order?: 'DESC' | 'ASC'
  size?: number
  sort?: string
}

/**
 * 接口响应码
 */
export enum ResponseCode {
  success = 200,
  unAuth = 401, // 未登录
  unRegisterSocial = 3001000, // 三方授权登录,未注册用户
  unCodeState = 999,
  maintain = 498, // 全站维护
  denyIp = 496 //拒绝访问
}
